import React, { Component } from 'react';
import MOBILE_CLASSES from './mobileStylesClasses';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';


class DayCell extends Component {

    render() {
        const { classes = MOBILE_CLASSES, empty, dayValue, onClick, dotClasses = [], boxClasses = [], isCurrentMonth = true } = this.props;

        if (empty) {
            return (
                <React.Fragment>
                    <div className={classes.emptyCalendarDayCell}>
                    </div>
                </React.Fragment>
            );
        }

        let shiftDots = [];
        for (const dot of dotClasses) {
            shiftDots.push(<div className={dot}></div>);
        }

        let shiftBoxes = [];
        for (const box of boxClasses) {
            if (boxClasses.length <= 0) { // Change this to get full width boxes
                shiftBoxes.push(<div className={clsx(classes.dayCellLongBox, box.class)}>{box.value}</div>);
            } else {
                shiftBoxes.push(<div className={clsx(classes.dayCellSmallBox, box.class)}>{box.value}</div>);
            }
        }

        const cellClasses = clsx(
            classes.calendarDayCell,
            !isCurrentMonth && classes.calendarDayCellOtherMonth
        );

        return (
            <React.Fragment>
                <div className={cellClasses} onClick={onClick}>
                    <div className={classes.calendarDayCellDots}>{shiftDots}</div>
                    <div className={classes.calendarDayCellDate}>{dayValue}</div>
                    <div className={classes.calendarDayCellBoxes}>{shiftBoxes}</div>
                </div>
            </React.Fragment>
        );
    }
}

export default withTranslation('employmentBillboard')(DayCell);
